import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Col, Modal, ModalBody, ModalFooter, Row } from 'reactstrap'
import { toast } from 'react-toastify'
import { Button } from 'src/Atoms'
import { CreateStripeOnboardingLink } from 'src/store/actions'

const StripAccess = (props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { admin } = useSelector((state) => state.Login)
    const [showModal, setShowModal] = useState({
        showModal: false,
        modalContact: ''
    })
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (!admin.connectedAcctData) {
            const modalObj = {
                showModal: true,
                modalContact: 'Please create stripe account first to complete account details.'
            }
            setShowModal(modalObj)
        }
    }, [admin.connectedAcctData])

    const toggle = () => {
        const modalObj = {
            showModal: false,
            modalContact: ''
        }
        setShowModal(modalObj)
        navigate('/dashboard')
    }

    const handleConnectStripe = async () => {
        setIsLoading(true)
        try {
            const res = await dispatch(CreateStripeOnboardingLink({})).unwrap()
            if (res?.url) {
                window.open(res.url, '_self')
            } else {
                toast.error('Failed to create onboarding link')
            }
        } catch (err) {
            const errorMsg = err?.message || err || 'Failed to connect Stripe account'
            toast.error(errorMsg)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            {props.children}
            <Modal isOpen={showModal.showModal} centered toggle={toggle}>
                <Row>
                    <Col className='text-end m-2'>
                        <Button
                            className='btn btn-danger'
                            onClick={toggle}
                            title='close'
                            color='primary'
                        >
                            X
                        </Button>
                    </Col>
                </Row>
                <ModalBody className=''>
                    <Row className='mt-2 py-2'>
                        <Col md={12} className='text-center mt-3'>
                            <h4>{showModal.modalContact}</h4>
                        </Col>
                    </Row>
                </ModalBody>{' '}
                <ModalFooter className='justify-content-center'>
                    <Row>
                        <Col md={12} className='mt-3'>
                            <Button
                                className='btn btn-primary w-lg waves-effect waves-light ms-2'
                                title='Connect Stripe Account'
                                color='primary'
                                onClick={handleConnectStripe}
                                disabled={isLoading}
                            >
                                {isLoading ? 'CONNECTING...' : 'CONNECT STRIPE ACCOUNT'}
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default StripAccess
